import {ExpenseManagementPage_viewer} from './__generated__/ExpenseManagementPage_viewer.graphql';

export type ExpenseItem = NonNullable<
	NonNullable<
		NonNullable<NonNullable<NonNullable<ExpenseManagementPage_viewer['company']>['expenseItems']>['edges']>[0]
	>['node']
>;

export type ExpenseRow = {
	totalCost: number;
	totalPrice: number | undefined;
	billingOption: string;
	markup: number | undefined;
	expenseDate: Date;
	month: Date;
	status: string;
	attachedFiles: string[];
	locked: boolean;
	readOnly: boolean;
} & ExpenseItem;

export enum ExpenseBoolean {
	TRUE = 'true',
	FALSE = 'false',
}
